import axios from 'axios';
import { API_BASE_URL } from '../../../config';

const orgBase = (organizationId) =>
  `${API_BASE_URL}/organizations/${organizationId}/payment-rail-settings`;

export class PaymentRailSettingsApi {
  static list = (organizationId, params = {}) =>
    axios.get(orgBase(organizationId), { params });

  static listForForms = (organizationId) =>
    axios.get(`${orgBase(organizationId)}/for-forms`);

  static get = (organizationId, id) =>
    axios.get(`${orgBase(organizationId)}/${id}`);

  static create = (organizationId, data) =>
    axios.post(orgBase(organizationId), data);

  static update = (organizationId, id, data) =>
    axios.put(`${orgBase(organizationId)}/${id}`, data);

  static delete = (organizationId, id) =>
    axios.delete(`${orgBase(organizationId)}/${id}`);
}
